__webpack_require__.p = "/workspace-lib-generator/referrals-hub/";